var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "titleTilted"
  }, "Mayhem tilted cross logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "titleTilted"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "softGlow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 18,
    fill: "#070707"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60,60) rotate(-20)",
    filter: "url(#softGlow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -36,
    width: 12,
    height: 72,
    rx: 3,
    fill: "none",
    stroke: "#D7263D",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -6,
    width: 40,
    height: 12,
    rx: 3,
    fill: "none",
    stroke: "#D7263D",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#D7263D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.94d8276cc78abef38a7eb6671ae88aca.svg";
export { ForwardRef as ReactComponent };